import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Vous avez {{length}} alertes',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Informations de paiement en cours de vérification',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Informations de paiement validées',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Erreur sur les informations de paiement',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        "Vos informations de paiement sont en cours de vérification par Stripe. Cela peut prendre jusqu'à 48 heures.",
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Vos informations de paiement ont été vérifiées avec succès. Vous pouvez désormais recevoir des paiements.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        "Une erreur semble s'être produite avec vos informations. Cliquez ici pour les mettre à jour.",
    },
  },
};
